import { Download, ArrowRight, ShieldCheck } from "lucide-react";
import { LOGO, HERO_BG } from "../../data/content";

export const Hero = () => {
  return (
    <section id="hero" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={HERO_BG} alt="" className="w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/85 to-[#0A0A0A]/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-[#0A0A0A]/70" />
      </div>
      <div className="absolute inset-0 tactical-grid opacity-60" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full pt-32 pb-20">
        <div className="max-w-4xl mx-auto text-center flex flex-col items-center">
          <div className="fade-up flex flex-wrap items-center justify-center gap-3 mb-10" style={{ animationDelay: "0.05s" }}>
            <span className="inline-flex items-center gap-2 border border-white/15 bg-white/5 px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-300">
              <ShieldCheck size={14} strokeWidth={2} /> Veteran-Owned Small Business
            </span>
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-500">SAM Active</span>
          </div>

          <img src={LOGO} alt="Atlas Contracting Group" className="fade-up w-[85%] max-w-[440px] sm:max-w-[560px] lg:max-w-[680px] h-auto object-contain mb-10" style={{ animationDelay: "0.1s" }} />

          <h1 className="fade-up font-sans font-black uppercase leading-[0.92] tracking-tight text-4xl sm:text-5xl lg:text-6xl text-white" style={{ animationDelay: "0.2s" }}>
            Mission-Ready <span className="metal-text">Procurement</span> & Contract Solutions
          </h1>

          <p className="fade-up mt-7 max-w-2xl mx-auto font-body text-base md:text-lg text-neutral-400 leading-relaxed" style={{ animationDelay: "0.4s" }}>
            Atlas Contracting Group LLC provides tactical equipment, operational supplies, safety products, and
            procurement support to government agencies — with disciplined sourcing and single-point coordination
            from requirement to delivery.
          </p>

          <div className="fade-up mt-10 flex flex-col sm:flex-row items-center justify-center gap-4" style={{ animationDelay: "0.5s" }}>
            <a
              href="#capabilities"
              data-testid="hero-capabilities-button"
              className="group inline-flex items-center justify-center gap-2 bg-white text-black font-sans font-bold uppercase tracking-widest px-8 py-4 hover:bg-neutral-300 transition-colors"
            >
              Explore Capabilities
              <ArrowRight size={18} strokeWidth={2.2} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#contact"
              data-testid="hero-quote-button"
              className="inline-flex items-center justify-center gap-2 border-2 border-white/25 text-white font-sans font-bold uppercase tracking-widest px-8 py-4 hover:border-white hover:bg-white/5 transition-all"
            >
              Request a Quote
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
